import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

const downloadAnalyticsStyles = async (
  jobId: number,
  styleId: string
): Promise<Blob> => {
  return apiClient
    .get(
      `${ENDPOINTS.ANALYTICS_STYLES_EXCEL_DOWNLOAD(
        jobId.toString()
      )}?styleId=${styleId}`
    )
    .blob();
};

export const useDownloadAnalyticsStylesQuery = (
  jobId: number | null,
  styleId: string,
  options?: Omit<UseQueryOptions<Blob, Error>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["downloadAnalyticsStyles", jobId, styleId],
    queryFn: () => {
      if (jobId === null) {
        throw new Error("jobId is null");
      }
      return downloadAnalyticsStyles(jobId, styleId);
    },
    enabled: false, // This ensures the query doesn't run automatically
    ...options,
  });
};
